import { isEmpty } from 'lodash';

import { ApiRequestResponse } from 'shared/interfaces';
import { FetchHeaders } from 'shared/types';
import { logoutUser } from 'utils/user/userAuth';
import { Log } from 'utils/log';

export function postConfig(
  body: Record<string, unknown>,
  headers: FetchHeaders
) {
  const postConfig: RequestInit = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
  };

  if (!isEmpty(body)) {
    postConfig.body = JSON.stringify(body);
  }

  return postConfig;
}

export async function getRequest(url: string, headers: FetchHeaders) {
  return request(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
  });
}

export function putConfig(
  body: Record<string, unknown>,
  headers: FetchHeaders
) {
  return {
    method: 'PUT',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
  };
}

export async function postRequest(
  url: string,
  body: Record<string, unknown>,
  headers: FetchHeaders
) {
  return request(url, postConfig(body, headers));
}

export async function putRequest(
  url: string,
  body: Record<string, unknown>,
  headers: FetchHeaders
) {
  return request(url, putConfig(body, headers));
}

export function deleteConfig(
  body: Record<string, unknown>,
  headers: FetchHeaders
) {
  const deleteConfig: RequestInit = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
  };

  if (!isEmpty(body)) {
    deleteConfig.body = JSON.stringify(body);
  }

  return deleteConfig;
}

export async function deleteRequest(
  url: string,
  body: Record<string, unknown>,
  headers: FetchHeaders
) {
  return request(url, deleteConfig(body, headers));
}

export async function request(url: string, config: RequestInit) {
  Log.debug('URL =>', url, 'CONFIG =>', config);
  let response;
  try {
    response = await fetch(url, config);
  } catch (e) {
    Log.error('fetch()', e);
  }

  if (
    response?.status === 401 &&
    !url.includes('/auth/login') &&
    !url.includes('/auth/logout') &&
    !url.includes('fast-upload') &&
    !url.includes('/api/media')
  ) {
    logoutUser();
  }

  let json = {};
  try {
    json = await response?.json();
  } catch (e) {
    Log.error('fetch() response.json()', e);
  }
  return {
    raw: response,
    status: response?.status,
    json,
    text: response?.text,
  } as ApiRequestResponse;
}

/**
 * Checks if request has errors.
 *
 * @param resp response from the request.
 * @return Returns true if request has errors, else false.
 */
export const requestHasErrors = (resp: ApiRequestResponse) => {
  return (
    resp.status !== 200 || resp.json?.errors || resp.json?.statusCode === 500
  );
};
